import classNames from 'helpers/class-names'
import { FC, HTMLAttributes } from 'react'

interface Props extends HTMLAttributes<HTMLTableRowElement> {
  isSelected?: boolean
}

export const TableRow: FC<Props> = ({
  isSelected = false,
  children,
  ...props
}) => {
  // TableVirtuoso doesn't like borders.
  const style = { boxShadow: '0 0.5px 0 #c4c7d4' }

  return (
    <tr
      {...props}
      data-selected={isSelected}
      className={classNames(
        'group relative border-b border-gray-50',
        {
          'hover:cursor-pointer': typeof props.onClick !== 'undefined',
        },
        props.className,
      )}
      style={style}>
      {children}
    </tr>
  )
}
